export default __webpack_public_path__ + "static/media/IMG_8262.856a0f22.webp";